'use client';

import * as RadixCollapsible from '@radix-ui/react-collapsible';
import { ReactElement } from 'react';

import { cn } from '@/lib/utils/tailwind';

import { CollapsibleContext, CollapsibleProps, rootVariants } from './types';

export const CollapsibleRoot = ({
  defaultOpen,
  placement = 'bottom',
  children,
  ref,
  ...props
}: CollapsibleProps): ReactElement => {
  return (
    <CollapsibleContext.Provider value={{ placement }}>
      <RadixCollapsible.Root
        className={cn(rootVariants({ placement }))}
        defaultOpen={defaultOpen}
        ref={ref}
        {...props}
      >
        {children}
      </RadixCollapsible.Root>
    </CollapsibleContext.Provider>
  );
};
